import type { InboxFullMessageFragment } from "@qw/graphql";
import { Badge, cn } from "@qw/ui";
import { useConversation } from "@/providers/use-conversation";

export const MessageFooter = ({ message }: { message: InboxFullMessageFragment }) => {
  const { displayFooters } = useConversation();

  if (!displayFooters) {
    return null;
  }

  const { classification, labels, status } = message;

  return (
    <footer className="mt-4 flex justify-between">
      <MessageLabels labels={labels} />
      <MessageStatus classification={classification} status={status} />
    </footer>
  );
};

const MessageLabels = ({ labels }: { labels: InboxFullMessageFragment["labels"] }) => (
  <div className="flex gap-2">
    {labels.map((label) => (
      <Badge key={label} variant="secondary" size="2xs">
        {label}
      </Badge>
    ))}
  </div>
);

const MessageStatus = ({ classification, status }: { classification: string | null | undefined; status: string }) => {
  return (
    <div className="flex gap-2">
      <Badge
        variant="secondary"
        size="2xs"
        className={cn({
          "bg-orange-100 text-orange-800": status === "pending",
          "bg-green-100 text-green-800": status === "classified",
        })}
      >
        {status}
      </Badge>
      {classification && (
        <Badge
          variant="secondary"
          size="2xs"
          className={cn({
            "bg-green-100 text-green-800": classification === "quote",
            "bg-blue-100 text-blue-800": classification === "submission",
          })}
        >
          {classification}
        </Badge>
      )}
    </div>
  );
};
